const ABNORMAL = 0;
const NOT_STARTED = 1;
const FIRST_SET = 432;
const SECOND_SET = 434;
const THIRD_SET = 436;
const FOURTH_SET = 438;
const FIFTH_SET = 440;
const ENDED = 100;
const POSTPONED = 14;
const DELAYED = 15;
const CANCELED = 16;
const INTERRUPTED = 17;
const CUT_IN_HALF = 19;
const TO_BE_DETERMINED = 99;

// Match Status
const ACES = 1;
const MAX_POINTS_IN_A_ROW = 2;
const POINTS_WON = 3;
const SERVICE_ERRORS = 4;
const TIMEOUTS = 5;
const SERVICE_POINTS_SUCCESS = 6;
const SERVICE_POINTS_TOTAL = 7;
const SERVICE_POINTS_RATE = 8;
const RECEIVER_POINTS_SUCCESS = 9;
const RECEIVER_POINTS_TOTAL = 10;
const RECEIVER_POINTS_RATE = 11;

const LIST_NOT_PLAYING = [
  ABNORMAL,
  NOT_STARTED,
  ENDED,
  POSTPONED,
  DELAYED,
  CANCELED,
  INTERRUPTED,
  CUT_IN_HALF,
  TO_BE_DETERMINED,
];

const LIST_PLAYING = [FIRST_SET, SECOND_SET, THIRD_SET, FOURTH_SET, FIFTH_SET];

export = {
  ABNORMAL,
  NOT_STARTED,
  FIRST_SET,
  SECOND_SET,
  THIRD_SET,
  FOURTH_SET,
  FIFTH_SET,
  ENDED,
  POSTPONED,
  DELAYED,
  CANCELED,
  INTERRUPTED,
  CUT_IN_HALF,
  TO_BE_DETERMINED,

  // Match Status
  ACES,
  TIMEOUTS,
  POINTS_WON,
  MAX_POINTS_IN_A_ROW,
  SERVICE_ERRORS,
  SERVICE_POINTS_SUCCESS,
  SERVICE_POINTS_TOTAL,
  SERVICE_POINTS_RATE,
  RECEIVER_POINTS_SUCCESS,
  RECEIVER_POINTS_TOTAL,
  RECEIVER_POINTS_RATE,

  // group status not playing
  LIST_NOT_PLAYING,

  LIST_PLAYING,
  LIST_STATUS_PLAYING: [
    FIRST_SET,
    SECOND_SET,
    THIRD_SET,
    FOURTH_SET,
    FIFTH_SET
  ],

  MATCH_STATUS_TEXT: {
    [ABNORMAL]: "Bất thường",
    [NOT_STARTED]: "Chưa bắt đầu",
    [FIRST_SET]: "SET 1",
    [SECOND_SET]: "SET 2",
    [THIRD_SET]: "SET 3",
    [FOURTH_SET]: "SET 4",
    [FIFTH_SET]: "SET 5",
    [ENDED]: "Kết thúc",
    [POSTPONED]: "Hoãn lại",
    [DELAYED]: "Bị trễ",
    [CANCELED]: "Đã hủy",
    [INTERRUPTED]: "Gián đoạn",
    [CUT_IN_HALF]: "Cắt đôi",
    [TO_BE_DETERMINED]: "Chưa xác định",
  },

  MATCH_STATUS_ACTIVE: [
    POINTS_WON,
    MAX_POINTS_IN_A_ROW,
    SERVICE_ERRORS,
    SERVICE_POINTS_SUCCESS,
    SERVICE_POINTS_TOTAL,
    SERVICE_POINTS_RATE,
    RECEIVER_POINTS_SUCCESS,
    RECEIVER_POINTS_TOTAL,
    RECEIVER_POINTS_RATE,
    ACES,
    TIMEOUTS,
  ],
};
